import React, { Component } from 'react';
import { connect } from 'react-redux';
import VATGROUPS_CONTROLLER from '../../controllers/vatGroups';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import BlankVATGroups from './BlankJSON/VATGroups';
import VATGroupDetails from './VATGroupDetails';
import VATGroupsForm from './VATGroupsForm';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';

const log = new Logger('VAT_GROUPS_PAGE', LOG_LEVELS.DEBUG);
class Page extends Component {


    getVATGroups(companyId) {
        log.debug('getVATGroups(): ', companyId,this.selectedCompanyId);
        if(this.props !== undefined && typeof this.props.onGetVATGroups === "function")
            this.props.onGetVATGroups(companyId);
    }

    deleteChild(companyId) {
        log.debug('deleteChild(): ', companyId);
        if(this.props !== undefined && typeof this.props.onDeleteChildVATGroup === "function")
            this.props.onDeleteChildVATGroup(companyId);
    }

    deleteParents(companyId) {
        log.debug('deleteParents(): ', companyId);
        if(this.props !== undefined && typeof this.props.onDeleteParentVATGroup === "function")
            this.props.onDeleteParentVATGroup(companyId);
    }
    addParentVATGroup(parentCompanyID,childCompanyIDs) {
        log.debug('addParentVATGroup(): ', parentCompanyID,childCompanyIDs);
        if(this.props !== undefined && typeof this.props.onAddParentVATGroup === "function")
            this.props.onAddParentVATGroup(parentCompanyID,childCompanyIDs);
    }

    addChildVATGroup(parentCompanyID,childCompanyID) {
        log.debug('addChildVATGroup(): ', parentCompanyID, childCompanyID);
        if(this.props !== undefined && typeof this.props.onAddChildVATGroup === "function")
            this.props.onAddChildVATGroup(parentCompanyID,childCompanyID);
    }
    filterSelectionHandler(keyValuePairs) {
        log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs);

        for(var i in keyValuePairs) {
            this.props.onGetVATGroups(keyValuePairs[i]);
        }
    }

    UNSAFE_componentWillMount() {
        log.debug('componentWillMount(): ', this.props);

        this.props.onPageLoad();
    }

    componentDidMount() {
        log.debug('componentDidMount()');
        log.clearAllDictionaryErrors();
    }

    render() {
        log.debug('render(): ', this.props);

        return (
            <div className="content-area">
                <s-container>
                    <h1><LanguageStringResolver string='TitleVATGroups'/></h1>
                    <VATGroupDetails
                        vatGroupList={this.props.vatGroups}
                        addChildVATGroupHandler={this.addParentVATGroup.bind(this)}
                        deleteChildVATGroupHandler={this.deleteParents.bind(this)}
                    />

                    <s-row className="mb40 mt20">
                        <s-col span="6">
                            <h2 className="pt20"><LanguageStringResolver string='vatGroups_createNewVATGroup'/></h2>
                            <s-box name="form-panel">
                                <VATGroupsForm 
                                    companySelectionLabel={<LanguageStringResolver string='vatGroups_SelectParent'/>}
                                    companyList={this.props.companyList}
                                    companySelectionFieldName='parentCompanyId'
                                    companyMultiSelectionLabel={<LanguageStringResolver string='vatGroups_SelectChild'/>}
                                    companyMultiSelectionFieldName='childCompanyIds'
                                    vatGroup={BlankVATGroups}
                                    submitHandler={this.addParentVATGroup.bind(this)}
                                    vatGroupList={this.props.vatGroups}
                                />
                                <div className="clear"></div>
                            </s-box>
                        </s-col>
                    </s-row>
                </s-container>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): state & starting props', state);
    return {
        vatGroups: state.vatGroups && state.vatGroups.data,
        companyList: (state.companies && state.companies.data) || [],
    };
}

function mapDispatchersToProps(dispatch) {
    return {

        onAddParentVATGroup: (parentCompanyID,childCompanyIDs) => {
            log.debug('onCreateVATGroup');
            dispatch(VATGROUPS_CONTROLLER.doAddParents(parentCompanyID,childCompanyIDs,));

        },
        onAddChildVATGroup: (parentCompanyID,childCompanyID) => {
            log.debug('onCreateVATGroup');
            var childCompanyIDs = [childCompanyID];
            dispatch(VATGROUPS_CONTROLLER.doAddChildren(parentCompanyID,childCompanyIDs));

        },
        onGetVATGroups: () => {
            log.debug('onGetVATGroups');
            dispatch(VATGROUPS_CONTROLLER.doGetVATGroups());

        },
        onPageLoad: () => {
            log.debug('onGetVATGroups');
            dispatch(VATGROUPS_CONTROLLER.doGetVATGroups());

        },

        onDeleteChildVATGroup: (companyId) => {
            log.debug('onDeleteChildVATGroup',companyId);
            dispatch(VATGROUPS_CONTROLLER.doDeleteChildren(companyId));

        },
        onDeleteParentVATGroup: (companyId) => {
            log.debug('onDeleteParentVATGroup',companyId);
            dispatch(VATGROUPS_CONTROLLER.doDeleteParents(companyId));

        },
    }
}

export default  authorize({
    name: 'VATGroups',
    resource: connect(mapStateToProps, mapDispatchersToProps)(Page)
  }, AuthorizedResource, {
    showNotAuthorized: true
  });
